import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Formsy, { addValidationRule } from 'formsy-react';
import { Link, withRouter } from "react-router-dom";
import logo from "../../assets/image/Treasurer.png";
import { V2_ACTIVE_COLOR, V2_BUTTON_COLOR, V2_INACTIVE_COLOR } from '../../config/color';
import HeartIcon from '../../assets/image/heart.png';
import LockIcon from '../../assets/image/lock.png';
import Input from '../../Components/Input';
import Radio from '../../Components/Input/radio';
import GooglePlayIcon from '../../assets/image/googlePlay.png';
import AppleStoreIcon from '../../assets/image/appleStore.png';
import { isValidEmailFormat, isValidUrlFormat, isValidPhoneNumberFormat } from '../../utils/validation';
import { seller } from '../../config/api';
import { Notice } from '../../Components/Notice';

const AppleLink = 'https://apps.apple.com/kr/app/%EC%96%BC%EB%A7%88%EC%95%BC/id1479169245';
const GoogleLink = 'https://play.google.com/store/apps/details?id=com.zikto.howmuch'

const UlmayaText = styled.div``;
const PartnerSection = styled.div``;
const PartnerSectionTop = styled.div``;
const PartnerSignUpFormSection = styled.div``;
const InputWrap = styled.div``;
const SubmitButtonContainer = styled.div``;

const Wrap = styled.div`
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  background-color: white;
  padding-top: 60px;

  @media (max-width: 768px) {
    padding-top: 40px;
  }
  /* top: -60px; */
`

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Section = styled.div`
  max-width: 858px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 0 20px;
  }

  ${UlmayaText} {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;

    @media (max-width: 768px) {
      margin-bottom: 30px;
      flex-direction: column;
    }

    h3 {
      font-size: 18px;

      @media (max-width: 768px) {
        font-size: 12px;
        margin-bottom: 20px;
      }
    }

    div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      button {
        width: 120px;
        background-color: white;
        padding: 0;

        &:is(:first-child) {
          margin-right: 20px;
        }

        @media (max-width: 768px) {
          width: 80px;
        }

        img {
          width: 100%;
        }
        /* width: 200px; */
      }
    }
  }

  ${PartnerSection} {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 30px;
      font-weight: 600;
      margin-bottom: 50px;

      @media (max-width: 768px) {
        font-size: 20px;
        margin-bottom: 30px;
      }
    }

    ${PartnerSectionTop} {
      width: 100%;

      div {
        &:is(:nth-child(1)) {
          width: 100%;
          p {
            &:is(:nth-child(1)) {
              width: 100%;
              height: 260px;
              border-radius: 16px;
              background-color: #EEEFF2;
              font-size: 14px;
              line-height: 24px;
              padding: 20px;
              overflow: scroll;

              @media (max-width: 768px) {
                font-size: 12px;
                height: 180px;
              }
            }
          }
          div {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 20px;

            @media (max-width: 768px) {
              margin-top: 10px;
              font-size: 12px;
            }
            
            input {
              margin-right: 10px;
              
            }
          }
        }
      }
    }
  }

  ${PartnerSignUpFormSection} {
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${InputWrap} {
      width: 100%;
      margin-bottom: 20px;

      @media (max-width: 768px) {
        margin-bottom: 30px;
      }
      
      label {
        color: #74777E;
        margin-bottom: 10px;
      }

      input {
        width: 100%;
        padding: 20px 24px;
        background-color: #EEEFF2;
        border-radius: 16px;

        @media (max-width: 768px) {
          border-radius: 12px;
          padding: 16px 24px;
        }

        ::placeholder {
          color: #AEAEAE;
          font-size: 14px;
          line-height: 20px;
        }
      }
      span {
        font-size: 12px;
        font-weight: 600;
        color: rgba(255, 110, 48, 0.8);
        @media (max-width: 768px) {
          font-size: 10px;
        }
      }

      p {
        margin-top: 14px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        span {
          font-size: 12px;
          font-weight: 600;
          color: rgba(255, 110, 48, 0.8);
          @media (max-width: 768px) {
            font-size: 10px;
          }
        }
      }
    }

    div {
      
      max-width: 430px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      h3 {
        color: #74777E;
        font-size: 18px;
        font-weight: 600;
        margin-top: 40px;
        margin-bottom: 20px;
      }

      p {
        width: 100%;
        font-size: 12px;
        font-weight: 400;
        color: #74777E;
        line-height: 20px;
        text-align: center;
      }

      &:is(:nth-child(2)) {
        /* margin-bottom: 30px; */
      }
    }
    ${SubmitButtonContainer} {
      margin-bottom: 40px;
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      button {
        background-color: ${V2_BUTTON_COLOR};
        color: white;
        padding: 16px 24px;
        border-radius: 16px;
        cursor: pointer;
      }
    }
  }
`


export default ({history}) => {
  const [emailError, setEmailError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passowrdError, setPasswordError] = useState("");
  const [shopUrlError, setShopUrlError] = useState("");
  const [shopPhoneNumberError, setShopPhoneNumberError] = useState("");
  const [successSignUp, setSuccessSignUp] = useState(false);
  const [checked, setChecked] = useState(false);

  const [signInfo, setSignInfo] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    shopName: '',
    shopUrl: '',
    shopNumber: '',
    shopClerkName: '',
    shopPhoneNumber: '',
  });
  const { email, password, confirmPassword, shopName, shopUrl, shopNumber, shopClerkName, shopPhoneNumber } = signInfo;

  const onChangeInput = e => {
    const { name, value } = e.target;
    setSignInfo({ ...signInfo, [name]: value });
  };

  useEffect(
    () => {
      if (!email) {
        setEmailError("");
      } else {
        if (isValidEmailFormat(email)) {
          setEmailError("");
        } else {
          setEmailError("올바른 이메일 형식이 아닙니다.");
        }
      }
    },
    [email]
  );

  useEffect(
    () => {
      if (!password) {
        setPasswordError("");
      } else {
        if (password.length < 8) {
          setPasswordError("비밀번호를 8자리 이상 입력해주세요.");
        } else {
          setPasswordError("");
        }
      }
    },
    [password]
  );

  useEffect(
    () => {
      if (!shopUrl) {
        setShopUrlError("");
      } else {
        if (isValidUrlFormat(shopUrl)) {
          setShopUrlError("");
        } else {
          setShopUrlError("올바른 웹사이트 형식이 아닙니다.");
        }
      }
    },
    [shopUrl]
  );

  useEffect(
    () => {
      if (!shopPhoneNumber) {
        setShopPhoneNumberError("");
      } else {
        if (isValidPhoneNumberFormat(shopPhoneNumber)) {
          setShopPhoneNumberError("");
        } else {
          setShopPhoneNumberError("올바른 휴대폰번호 형식이 아닙니다.");
        }
      }
    },
    [shopPhoneNumber]
  );

  useEffect(
    () => {
      if (!confirmPassword || !password) {
        setConfirmPasswordError("");
      } else {
        if (password !== confirmPassword) {
          setConfirmPasswordError("비밀번호가 다르게 입력되었습니다.");
        } else {
          setConfirmPasswordError("");
        }
      }
    },
    [password, confirmPassword]
  );

  const formRef = React.createRef();

  const _pushAppLink = (link) => {
    window.open(link, '_blank')
  }

  const replaceHyphen = (value) => {
    const check = value.replace(/-/gi,'');
    return check;
  }

  const handleSubmit = async () => {
    
    try {
      if(!checked) {
        alert('약관에 동의해주세요.');
        return
      }
      const r = await seller.sellerRegistration(email, password, shopName, shopUrl, replaceHyphen(shopNumber), shopClerkName, replaceHyphen(shopPhoneNumber));
      if(r.data.message === 'found an existing seller') {
        alert('이미 가입되어있는 휴대폰번호 입니다.');
        history.push('/signin')
      } else if(r.data.message === 'created a new seller') {
        setSuccessSignUp(true);
        // alert('입점 신청이 완료되었습니다.');
        // history.push('/signin')
      }
    } catch(e) {
      console.log(e)
    }
  }

  return (
    <Wrap>
      {!successSignUp ? (
        <Container>
          <Section>
            <UlmayaText>
              <h3>
                개인 고객은 얼마야를 통해서 내물건의 가치를 찾아보세요.
              </h3>
              <div>
                <button onClick={() => {
                  _pushAppLink(AppleLink)
                }}>
                  {/* iOS */}
                  <img src={AppleStoreIcon} />
                </button>
                <button onClick={() => {
                  _pushAppLink(GoogleLink)
                }}>
                  {/* Android */}
                  <img src={GooglePlayIcon} />
                </button>
              </div>
            </UlmayaText>
            <PartnerSection>
              <h2>파트너 회원가입</h2>
              <PartnerSectionTop>
                <div>
                  <p>
                    제 1장 총칙<br/>
                    제 1조[목적]<br/>
                    본 이용약관은 얼마야 주식회사(이하 “회사"라 합니다)와 회사가 운영하는 얼마야(ULMAYA)”서비스(이하 “얼마야"라 합니다)를 이용하여 자신의 상품, 재화 등을
                    홍보 및 판매하고자 하는 자(이하 “쇼핑몰 사업자"라 합니다)사이의 권리, 의무, 기타 필요한 사항을 정함으로써 상호 이익을 도모하는 것을 그 목적으로 합니다.
                    <br/><br/>
                    제 2조[용어의 정의]<br/>
                    본 이용약관에서 사용하는 용어의 정의는 다음과 같습니다. <br/>
                    1. "얼마야"는 회사가 운영하는 앱 또는 웹 형태의 플랫폼으로서 각 쇼핑몰에 게시된 상품정보를  취합하여 이용자들에게 보여주고, 이용자들로 하여금 구매를 촉진시키
                    거나 쇼핑을 편리하게 하는 기능을 제공하는 가상의 영업장을 의미합니다.
                  </p>
                  <div>
                    <input type="checkbox" defaultChecked={checked} onChange={() => setChecked(!checked)} />
                    <p>
                      서비스 이용약관에  동의합니다.
                    </p>
                  </div>
                </div>
              </PartnerSectionTop>
              <PartnerSignUpFormSection>
                <Formsy
                  onValidSubmit={() => handleSubmit()}
                  ref={formRef}
                >
                  <div>
                    <h3>계정 정보 입력</h3>
                    <InputWrap>
                      <label>
                        이메일 <span>*</span>
                      </label>
                      <input
                        style={{border: emailError ? `1px solid ${V2_BUTTON_COLOR}` : 'none'}}
                        required
                        type={'text'}
                        name={'email'}
                        onChange={onChangeInput}
                        placeholder={'이메일을 입력해주세요. 아이디로 사용됩니다.'}
                        value={email}
                      />
                      {emailError && (
                        <p>
                          <span>{emailError}</span>
                        </p>
                      )}
                    </InputWrap>
                    <InputWrap>
                      <label>
                        비밀번호 <span>*</span>
                      </label>
                      <input
                        style={{border: passowrdError ? `1px solid ${V2_BUTTON_COLOR}` : 'none'}}
                        required
                        type={'password'}
                        name={'password'}
                        onChange={onChangeInput}
                        placeholder={'비밀번호를 입력해주세요.'}
                        minLength={8}
                        value={password}
                      />
                      {passowrdError && (
                        <p>
                          <span>{passowrdError}</span>
                        </p>
                      )}
                    </InputWrap>
                    <InputWrap>
                      <label>
                        비밀번호 확인 <span>*</span>
                      </label>
                      <input
                        style={{border: confirmPasswordError ? `1px solid ${V2_BUTTON_COLOR}` : 'none'}}
                        required
                        type={'password'}
                        name={'confirmPassword'}
                        onChange={onChangeInput}
                        placeholder={'비밀번호를 입력해주세요.'}
                        minLength={8}
                        value={confirmPassword}
                      />
                      {confirmPasswordError && (
                        <p>
                          <span>{confirmPasswordError}</span>
                        </p>
                      )}
                    </InputWrap>
                    <h3>쇼핑몰 정보 입력</h3>
                    <InputWrap>
                      <label>
                        쇼핑몰 이름 <span>*</span>
                      </label>
                      <input
                        required
                        type={'text'}
                        name={'shopName'}
                        onChange={onChangeInput}
                        placeholder={'쇼핑몰 이름을 입력하세요.'}
                        value={shopName}
                      />
                    </InputWrap>
                    <InputWrap>
                      <label>
                        쇼핑몰 사이트 URL <span>*</span>
                      </label>
                      <input
                        style={{border: shopUrlError ? `1px solid ${V2_BUTTON_COLOR}` : 'none'}}
                        required
                        type={'text'}
                        name={'shopUrl'}
                        onChange={onChangeInput}
                        placeholder={'http://'}
                        value={shopUrl}
                      />
                      {shopUrlError && (
                        <p>
                          <span>{shopUrlError}</span>
                        </p>
                      )}
                    </InputWrap>
                    <InputWrap>
                      <label>
                        고객센터 번호 <span>*</span>
                      </label>
                      <input
                        required
                        type={'text'}
                        name={'shopNumber'}
                        onChange={onChangeInput}
                        placeholder={'- 없이 입력해주세요.'}
                        value={shopNumber}
                      />
                      <p>
                        <span>
                          고객문의를 원활하게 연결할 수 있도록 쇼핑몰 고객센터 번호를 입력해 주세요.
                        </span>
                        <span>
                          *잘못된 번호를 기입하면, 입점 심사 과정에서 불이익이 있을 수 있습니다. 
                        </span>
                      </p>
                    </InputWrap>
                    <h3>쇼핑몰 담당자 정보 입력</h3>
                    <InputWrap>
                      <label>
                        이름 <span>*</span>
                      </label>
                      <input
                        required
                        type={'text'}
                        name={'shopClerkName'}
                        onChange={onChangeInput}
                        placeholder={'담당자 성함을 입력해주세요.'}
                        value={shopClerkName}
                      />
                    </InputWrap>
                    <InputWrap>
                      <label>
                        휴대폰 <span>*</span>
                      </label>
                      <input
                        required
                        style={{border: shopPhoneNumberError ? `1px solid ${V2_BUTTON_COLOR}` : 'none'}}
                        type={'text'}
                        name={'shopPhoneNumber'}
                        onChange={onChangeInput}
                        placeholder={'- 없이 입력해주세요.'}
                        value={shopPhoneNumber}
                      />
                      {shopPhoneNumberError && (
                        <p>
                          <span>{shopPhoneNumberError}</span>
                        </p>
                      )}
                      <p>
                        <span>
                          연락 가능한 휴대폰 번호를 입력해 주세요.
                        </span>
                        <span>
                          *위 번호는 외부로 유출되지 않습니다.
                        </span>
                      </p>
                    </InputWrap>
                    {/* <h3>자체 사이트/채널 보유 여부</h3>
                    <Radio
                      title={'쇼핑몰 공식 블로그'}
                      noticeMessage={'블로그 보유 여부를 선택해 주세요.'}
                    /> */}
                  </div>
                  <div>
                    <p>
                      입점 신청 후 10일 내에 입점 가능 여부를 입력하신 메일로 안내 드립니다.
                    </p>
                    <p>
                      문의 : 02)1670-8051, 평일 09:00 - 18:00(토/일/공휴일 휴무, 점심 13:00 - 14:00)
                    </p>
                  </div>
                  <SubmitButtonContainer>
                    <button type="submit" disabled={shopUrlError || emailError || confirmPasswordError}>
                      입점 신청하기
                    </button>
                  </SubmitButtonContainer>
                </Formsy>
              </PartnerSignUpFormSection>
            </PartnerSection>
          </Section>
        </Container>
      ) : <Notice active={true} />}
    </Wrap>
  )
}